import script from "./Logo.vue?vue&type=script&setup=true&lang=ts"
export * from "./Logo.vue?vue&type=script&setup=true&lang=ts"

import "./Logo.vue?vue&type=style&index=0&id=f0e6e8e2&lang=css"

const __exports__ = script;

export default __exports__